import React from 'react'
import { useSelector } from 'react-redux'

const Steper = () => {
    const { stepperWidth } = useSelector(state => state.newCompaign);

    return (
        <div className='w-full bg-gray-200 h-2.5 relative mt-8 rounded-full'>
            <div className='absolute top-0 gradient-bg left-0 rounded-full h-full'
            style={{
                width : stepperWidth + "%"
            }}></div>
        </div>
    )
}

export default Steper